import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error details
    /// console.error('ErrorBoundary caught an error:', error);
    /// console.error('Error info:', errorInfo);
    
    // React Error #31 특별 처리
    if (error.message?.includes('Minified React error #31')) {
      /// console.error('🚨 React Error #31 감지: Promise가 JSX에서 직접 렌더링되려고 했습니다.');
      /// console.error('컴포넌트 스택:', errorInfo.componentStack);
    }
    
    // React Error #130 특별 처리 
    if (error.message?.includes('Minified React error #130')) {
      /// console.error('🚨 React Error #130 감지: 객체가 JSX에서 직접 렌더링되려고 했습니다.');
      /// console.error('컴포넌트 스택:', errorInfo.componentStack);
      /// console.error('해결방법: 객체를 String()으로 변환하거나 적절한 속성에 접근하세요.');
    }
    
    // React Error #418 특별 처리 (Hydration 오류)
    if (error.message?.includes('Minified React error #418')) {
      /// console.error('🚨 React Error #418 감지: Hydration 오류 - 서버와 클라이언트 렌더링 결과가 다릅니다.');
      /// console.error('컴포넌트 스택:', errorInfo.componentStack);
    }
    
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          padding: '20px',
          border: '1px solid #ff4444',
          borderRadius: '8px',
          backgroundColor: '#fff5f5',
          color: '#d63384'
        }}>
          <h3>앱에서 오류가 발생했습니다</h3>
          <p>페이지를 새로고침하거나 다시 시도해주세요.</p>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '10px' }}>
              <summary>오류 상세 정보 (개발 모드)</summary>
              <pre style={{ 
                fontSize: '12px', 
                backgroundColor: '#f8f9fa', 
                padding: '10px', 
                overflow: 'auto',
                whiteSpace: 'pre-wrap'
              }}>
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '10px',
              padding: '8px 16px',
              backgroundColor: '#448181',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            페이지 새로고침
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
